import { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { ROUTE } from "@/route/app_routes.js";

const EventHead = ({ upcoming, search }) => {
  const { t } = useTranslation("events");
  const router = useRouter();
  const [searchTerm, setSearchTerm] = useState(search || "");

  const updateQuery = (patch) => {
    const query = { ...router.query };
    delete query.path;
    Object.entries(patch).forEach(([key, value]) => {
      if (value) query[key] = value;
      else delete query[key];
    });
    router.push({ pathname: ROUTE.events, query });
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    updateQuery({ search: searchTerm.trim() });
  };

  return (
    <div className="rbt-events-hero">
      <div className="container">
        <span className="eyebrow">
          <i className="feather-zap"></i>
          {t("hero.eyebrow", "Free, community-run tech events")}
        </span>
        <h1 className="title">{t("hero.title", "Bringing you closer to all the events you love")}</h1>
        <p className="description">
          {t("hero.description", "Free meetups, workshops, and tech talks — created by the community, for the community.")}
        </p>

        <div className="rbt-events-hero__row">
          <div className="rbt-events-hero__filters">
            <form className="rbt-events-hero__search" onSubmit={handleSearchSubmit}>
              <i className="feather-search"></i>
              <input
                type="text"
                placeholder={t("hero.searchPlaceholder", "Search events…")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button type="submit">{t("hero.searchButton", "Search")}</button>
            </form>

            <div className="rbt-events-hero__toggle">
              <button
                type="button"
                className={upcoming !== "false" ? "is-active" : ""}
                onClick={() => updateQuery({ upcoming: "" })}
              >
                {t("hero.filters.upcoming", "Upcoming")}
              </button>
              <button
                type="button"
                className={upcoming === "false" ? "is-active" : ""}
                onClick={() => updateQuery({ upcoming: "false" })}
              >
                {t("hero.filters.past", "Past")}
              </button>
            </div>

            <Link className="rbt-events-hero__find-tickets" href={ROUTE.findMyTicket}>
              <i className="feather-search"></i>
              {t("hero.findMyTicket", "Find my tickets")}
            </Link>
          </div>

          <Link className="rbt-btn btn-gradient hover-icon-reverse" href={ROUTE.dashboardEventsCreate}>
            <span className="icon-reverse-wrapper">
              <span className="btn-text">{t("hero.createButton", "Create a Free Event")}</span>
              <span className="btn-icon"><i className="feather-arrow-right"></i></span>
              <span className="btn-icon"><i className="feather-arrow-right"></i></span>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventHead;
